/**
 * Device Selector
 * Handles device selection dropdown for feature products
 */

/**
 * Initialize device selector
 */
export function initializeDeviceSelector() {
  const serialFromUrl = getSerialFromUrl()
  const devicesList = document.querySelectorAll('.devices-list li')

  // Initialize dropdown toggle
  initializeDropdownToggle()

  // Initialize device selection
  initializeDeviceSelection(devicesList)

  // Auto-select device from URL parameter
  autoSelectDevice(serialFromUrl, devicesList)
}

/**
 * Get serial number from URL parameter
 */
function getSerialFromUrl() {
  return new URLSearchParams(window.location.search).get('serial')
}

/**
 * Initialize dropdown toggle
 */
function initializeDropdownToggle() {
  const openDevicesButton = document.querySelector('.open-devices-list')
  const deviceListWrapper = document.querySelector('.device-list-wrapper')

  if (!openDevicesButton || !deviceListWrapper) return

  openDevicesButton.addEventListener('click', () => {
    openDevicesButton.classList.toggle('active')
    deviceListWrapper.style.display = deviceListWrapper.style.display === 'block' ? 'none' : 'block'
  })
}

/**
 * Initialize device selection from list
 */
function initializeDeviceSelection(devicesList) {
  devicesList.forEach(device => {
    device.addEventListener('click', () => {
      const serialNumber = device.querySelector('.sn span')?.textContent
      const deviceType = device.querySelector('strong')?.textContent
      const chipId = device.dataset.chip

      if (!serialNumber || !deviceType) return

      updateSelectedDevice(deviceType, serialNumber, chipId)
      hideDropdown()
    })
  })
}

/**
 * Update selected device display and form inputs
 */
function updateSelectedDevice(deviceType, serialNumber, chipId) {
  const openDevicesButton = document.querySelector('.open-devices-list')

  // Update button display
  if (openDevicesButton) {
    const typeElement = openDevicesButton.querySelector('strong')
    const serialElement = openDevicesButton.querySelector('.sn span')

    if (typeElement) typeElement.textContent = deviceType
    if (serialElement) serialElement.textContent = serialNumber
  }

  // Update form inputs
  const serialInput = document.querySelector('input[name="serial_number"]')
  const chipInput = document.querySelector('input[name="chip_id"]')

  if (serialInput) serialInput.value = serialNumber
  if (chipInput) chipInput.value = chipId
}

/**
 * Hide dropdown
 */
function hideDropdown() {
  const deviceListWrapper = document.querySelector('.device-list-wrapper')
  const openDevicesButton = document.querySelector('.open-devices-list')

  if (deviceListWrapper) {
    deviceListWrapper.style.display = 'none'
  }

  if (openDevicesButton) {
    openDevicesButton.classList.remove('active')
  }
}

/**
 * Auto-select device from URL parameter
 */
function autoSelectDevice(serialFromUrl, devicesList) {
  if (!serialFromUrl || devicesList.length === 0) return

  devicesList.forEach(device => {
    const serialNumber = device.querySelector('.sn span')?.textContent
    if (serialNumber === serialFromUrl) {
      device.click()
    }
  })
}
